import React, { useEffect } from "react";
import { v4 as uuidv4 } from 'uuid';
import { showMessage } from "services/message.js";

//Context
import { useAuth } from "../../context/auth";

export default function InputPDF(props) {
    const { setupSistema } = useAuth();
    const inputImage = React.useRef(null);
    const [image, setImage] = React.useState(props.image == null ? require("assets/img/document.png") : require("assets/img/document-ok.png"))
    const handleImage = (event) => {
        event.preventDefault();
        
        if (event.target.files.length) {
            const file = event.target.files[0];
            const fsize = Math.round((file.size / 1024));

            if (fsize == 0) {
                showMessage("Aviso", "Arquivo selecionado está inválido, ou, o tamanho é insuficiente. Tamanho do aquivo: " + fsize + "MB", 'error', null);
                return;
            }
            if (fsize > 21504) {
                showMessage("Aviso", "O limite máximo permitido para importação é de 21MB.", 'error', null);
                return;
            }
            if (props.onlyPDF ? file.type !== "application/pdf" : (file.type !== "image/png" && file.type !== "image/jpeg" && file.type !== "application/pdf")) {
                showMessage("Aviso", "Formato do arquivo " + file.type + " inválido. O arquivo deve estar nos formatos: " + (props.onlyPDF ? "PDF" : "PNG/JPEG/PDF"), 'error', null);
                return;
            }

            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = function () {
                var base64data = reader.result;
                props.handlefile(
                    {
                        base64: base64data.replace("data:image/png;base64,", "").replace("data:image/jpeg;base64,", "").replace("data:application/pdf;base64,", ""),
                        name: uuidv4() + ".pdf",
                        documento_Id: props.documento_id
                    },
                    function () {
                        setImage(require("assets/img/document-ok.png"));
                    }
                );
            }
        }
    }
    const handleClickImage = (event) => {
        event.preventDefault();
        inputImage.current.click();
    }

    useEffect(() => {
        if (props.image != null)
            setImage(require("assets/img/document-ok.png"));
        else
            setImage(require("assets/img/document.png"));
    }, [props.image]);

    return (
        <>
            <input
                {...props}
                type="file"
                accept=".pdf"
                ref={inputImage}
                className={"d-none"}
                onChange={(event) => { handleImage(event); event.target.value = null; }}
            />
            <img style={{ height: (props.height == null ? "7rem" : props.height), maxWidth: (props.width == null ? "7rem" : props.width), cursor: "pointer" }} src={image} onClick={handleClickImage} />
            <br />
            {(props.image != null && props.image.base64 == null) &&
                <a target="_blank" href={setupSistema?.caminhoVirtual + props.image.name}>Abrir Arquivo</a>}
        </>
    )
}